import {MuWidget} from "mu-widget/lib/MuWidget";
import {BaseModule} from "./dms/BaseModule";
import {UiModalContainer} from "./UiModalContainer";
import {BaseMuWidget} from "./BaseMuWidget";

export class BaseWidget extends BaseMuWidget {
}